var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-swap"},[_c('f-view-transition',{attrs:{"watch-route":"","views-structure":_vm.viewsStructure}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }